<template>
  <div class="box">
    <div class="left-box">
      <div class="head-box">
        <h4>功能注册</h4>
        <div>
          <i
            class="el-icon-circle-plus-outline c-pointer"
            @click="
              editMenu = {};
              profileFileList = [];
              logoImageUrl = '';
              menuDialog = true;
            "
          ></i>
          <i class="el-icon-edit c-pointer c-m-l-10" @click="menuEdit()"></i>
          <i class="el-icon-delete c-pointer c-m-l-10" @click="menuDelete()"></i>
        </div>
      </div>
      <div class="left-content tree">
        <el-tree
          refs="tree"
          :data="treeData"
          :props="defaultProps"
          default-expand-all
          node-key="id"
          :indent="40"
          highlight-current
          :expand-on-click-node="false"
          @node-click="nodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i :class="data.code" class="c-m-l-10 c-m-r-10"></i>
            <span>{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="right-box c-p-10">
      <el-button
        class="tab-button"
        type="primary"
        @click.native="menuAdd()"
        v-if="activeTab == 'menu'"
      >
        添加菜单
      </el-button>
      <el-button
        class="tab-button"
        type="primary"
        @click.native="buttonAdd()"
        v-if="activeTab == 'button'"
      >
        添加按钮
      </el-button>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="菜单" name="menu">
          <el-table
            :data="activeNode.functionList"
            empty-text="暂无子菜单"
            style="width: 100%"
            highlight-current-row
          >
            <el-table-column
              prop="actCode"
              label="当前套餐"
              :formatter="formatterSuit"
            ></el-table-column>
            <el-table-column prop="order" label="菜单编号"></el-table-column>
            <el-table-column prop="name" label="菜单名称"></el-table-column>
            <el-table-column prop="action" label="菜单地址" width="280px"></el-table-column>
            <el-table-column prop="code" label="菜单图标"></el-table-column>
            <el-table-column
              prop="functionTypeList"
              label="类型"
              :formatter="formatFunctionTypeList"
            ></el-table-column>

            <el-table-column prop="logoImageUrl" label="菜单Logo">
              <template slot-scope="scope">
                <img :src="scope.row.logoImageUrl" min-width="70" height="70" />
              </template>
            </el-table-column>

            <el-table-column label="图标颜色">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.color"
                  effect="dark"
                  :color="scope.row.color"
                  style="border:none;"
                >
                  {{ scope.row.color }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="openType" label="路由方式"></el-table-column>
            <!-- 当前是底部导航栏 才回用到这个两个字段 -->
            <template v-if="activeNode.memo == 'Tabbar'">
              <el-table-column prop="exts.iconPath" label="激活前图标"></el-table-column>
              <el-table-column prop="exts.selectedIconPath" label="激活后图标"></el-table-column>
            </template>

            <el-table-column label="工单列表展示" width="150">
              <template slot-scope="scope">
                <el-switch
                  disabled
                  v-model="scope.row.exts.tabDisplay"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button @click.native.prevent="menuEdit(scope.row, scope.$index)" size="mini">
                  编辑
                </el-button>
                <el-button @click.native.prevent="menuDelete(scope.row, scope.$index)" size="mini">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--菜单编辑-->
          <el-dialog
            :close-on-click-modal="false"
            title="菜单注册"
            :visible.sync="menuDialog"
            width="600px"
          >
            <el-form :model="editMenu" :rules="editMenuRules" ref="editMenu" label-width="100px">
              <el-form-item label="客户端" prop="clientType">
                <el-select v-model="editMenu.clientType">
                  <el-option
                    v-for="item in options.clientType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="套餐等级" prop="actCode" v-if="type == 'c'">
                <el-select v-model="editMenu.actCode">
                  <el-option
                    v-for="item in options.vipSuit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="菜单编号" prop="order">
                <el-input v-model.number="editMenu.order" placeholder="请填写菜单编号"></el-input>
              </el-form-item>
              <el-form-item label="菜单名称" prop="name">
                <el-input v-model="editMenu.name" placeholder="请填写菜单名称"></el-input>
              </el-form-item>

              <el-form-item label="菜单Logo" prop="logoImageUrl">
                <el-upload
                  v-model="editMenu.logoImageUrl"
                  :action="upload.url"
                  :data="upload.data"
                  :file-list="profileFileList"
                  list-type="picture-card"
                  :limit="upload.limit"
                  :on-exceed="osg.uploadExceed"
                  :before-upload="
                    file => {
                      return osg.beforeUpload(file, 'image');
                    }
                  "
                  :on-success="
                    (response, file, fileList) => {
                      editMenu.logoImageUrl = upload.downloadUrl + response.key;
                    }
                  "
                  :on-error="osg.uploadError"
                  :before-remove="
                    (file, fileList) => {
                      return beforeRemove(file, fileList, 'fileList');
                    }
                  "
                  :on-remove="
                    (file, fileList) => {
                      editMenu.logoImageUrl = '';
                    }
                  "
                  :on-preview="preivew"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :modal="false"
                  custom-class="dialog-img"
                  :visible.sync="upload.dialogVisible"
                >
                  <img width="100%" :src="upload.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>

              <el-form-item label="菜单描述">
                <el-input v-model="editMenu.memo" placeholder="请填写菜单描述"></el-input>
              </el-form-item>

              <el-form-item v-if="editMenu.exts" label="工单列表展示">
                <el-switch
                  v-model="editMenu.exts.tabDisplay"
                  active-value="1"
                  inactive-value="0"
                  placeholder="请填写菜单描述"
                ></el-switch>
              </el-form-item>

              <el-form-item label="菜单地址">
                <el-input
                  v-model="editMenu.action"
                  placeholder="请填写/菜单路由地址，一级菜单无需填写"
                ></el-input>
              </el-form-item>
              <el-form-item label="菜单图标">
                <el-input
                  v-model="editMenu.code"
                  placeholder="支持element和fontawesome图标库"
                ></el-input>
              </el-form-item>
              <!-- 当前是底部导航栏 才回用到这个两个字段 -->
              <template v-if="editMenu.exts && activeNode.memo == 'Tabbar'">
                <el-form-item
                  required
                  prop="exts.iconPath"
                  label="激活前图标"
                  :rules="[{ required: true, message: '激活前图标不能为空', trigger: 'blur' }]"
                  v-if="editMenu.exts.hasOwnProperty('iconPath')"
                >
                  <el-input
                    v-model="editMenu.exts.iconPath"
                    placeholder="支持本地文件路径以及网络路径"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="激活后图标"
                  prop="exts.selectedIconPath"
                  required
                  :rules="[{ required: true, message: '激活前图标不能为空', trigger: 'blur' }]"
                  v-if="editMenu.exts.hasOwnProperty('selectedIconPath')"
                >
                  <el-input
                    v-model="editMenu.exts.selectedIconPath"
                    placeholder="支持本地文件路径以及网络路径"
                  ></el-input>
                </el-form-item>
              </template>

              <el-form-item label="类型" v-if="editMenu.clientType != 'pc'">
                <el-select v-model="editMenu.functionTypeList" multiple placeholder="请选择类型">
                  <el-option
                    v-for="item in options.functionTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="图标颜色" v-if="editMenu.clientType != 'pc'">
                <el-input v-model="editMenu.color" placeholder="小程序导航icon颜色"></el-input>
              </el-form-item>
              <el-form-item label="路由方式" v-if="editMenu.clientType != 'pc'">
                <el-select v-model="editMenu.openType">
                  <el-option
                    v-for="item in options.openType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="menuSave(editMenu)">确 定</el-button>
              <el-button @click="menuDialog = false">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="按钮" name="button">
          <el-table :data="activeNode.buttonList" empty-text="此模块未添加按钮" style="width: 100%">
            <el-table-column prop="code" label="按钮编号" width="180"></el-table-column>
            <el-table-column prop="label" label="按钮名称" width="180">
              <template slot-scope="scope">
                <el-button @click.native.prevent="buttonEdit(scope.row)" type="primary" plain>
                  {{ scope.row.label }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="memo" label="描述"></el-table-column>
            <el-table-column label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="buttonEdit(scope.row, scope.$index)" type="text">
                  <div></div>
                  编辑
                </el-button>
                <el-button
                  @click.native.prevent="buttonDelete(scope.row, scope.$index)"
                  type="text"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--编辑按钮-->
          <el-dialog title="按钮注册" :visible.sync="buttonDialog" width="500px">
            <el-form :model="editButton">
              <el-form-item label="按钮编号" label-width="100px">
                <el-input v-model="editButton.code"></el-input>
              </el-form-item>
              <el-form-item label="按钮名称" label-width="100px">
                <el-input v-model="editButton.label"></el-input>
              </el-form-item>
              <el-form-item label="按钮描述" label-width="100px">
                <el-input v-model="editButton.memo"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="buttonSave()">确 定</el-button>
              <el-button @click="buttonDialog = false">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'register',
  data() {
    return {
      activeTab: 'menu', //当前激活tab
      menuDialog: false,
      buttonDialog: false,
      type: null, // 菜单类型，入口传参
      activeNode: '', //当前选中树节点
      editMenuIndex: '', //编辑菜单下标
      editButtonIndex: '', //编辑按钮下标
      editMenu: {}, //当前编辑的menu
      editMenuRules: this.$util.rules,
      editButton: {}, //当前编辑的button

      treeData: [],
      defaultProps: {
        children: 'functionList',
        label: 'name'
      },
      options: {
        codecfg_vipSuit: { codeId: 'VIPSUIT' },
        codecfg_clientType: { codeId: 'clientType' },
        codecfg_openType: { codeId: 'openType' },
        codecfg_functionTypeList: { codeId: 'functionTypeList' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      },
      //logo的数组
      profileFileList: [],
      logoImageUrl: ''
    };
  },
  mounted() {
    this.doInit();
  },
  methods: {
    formatFunctionTypeList(row, column, cellValue) {
      return this.osg.codelabelForArray('functionTypeList', cellValue);
    },
    doInit() {
      window.$this = this;
      this.type = this.osg.param('type');
      this.getMenu();
      // 查询字典表
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'account',
          _all: '1',
          'is:state|integer#and': 1,
          'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFields = res.data;
          this.options = this.options || [];

          for (var item of res.data) {
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
          }
          this.osg.codeoption(() => {});
        },
        { noload: true }
      );
    },
    //标签页切换
    handleClick(tab, event) {},
    //重置表单
    resetFields(formName) {
      this.$refs[formName].resetFields();
    },
    //添加菜单
    menuAdd() {
      //不直接赋值为空{}  加入exts
      // 设置 this.editMenu 为一个空对象

      this.editMenu = {};
      // 使用 $set 方法为 editMenu 添加 exts 属性，并确保其响应性
      this.$set(this.editMenu, 'exts', {
        iconPath: '',
        selectedIconPath: '',
        tabDisplay: '0' // 默认关闭
      });
      this.profileFileList = [];
      this.logoImageUrl = '';
      this.menuDialog = true;

      // 添加的时候清楚上一次的效验
      // this.$nextTick(() => {
      //   if (this.$refs.editMenu) this.$refs.editMenu.clearValidate();
      // });
    },
    //点击节点
    nodeClick(obj) {
      //检查数组中是否有
      obj.functionList.forEach(item => {
        item.exts = {
          iconPath: item.exts.iconPath ? item.exts.iconPath : '',
          selectedIconPath: item.exts.selectedIconPath ? item.exts.selectedIconPath : '',
          tabDisplay: item.exts.tabDisplay ? item.exts.tabDisplay : '0' // 默认开启
        };
      });

      this.activeNode = obj;
    },
    //获取菜单
    getMenu() {
      this.osg.ajax('function/queryTree.do', { type: this.type }, res => {
        this.treeData = res.data.functionList;
      });
    },
    //编辑菜单按钮
    menuEdit(obj, index) {
      this.osg.codeoption(() => {});
      this.editMenuIndex = index;
      console.log('编辑按钮反显', obj);

      if (obj) {
        this.editMenu = obj; //this.$util.deepCopy(obj);
      } else {
        if (!this.activeNode) {
          this.osg.toast('请选择要编辑菜单！', 'warning');
          return;
        }
        this.editMenu = this.$util.deepCopy(this.activeNode);
      }
      if (
        (typeof this.editMenu.logoImageUrl == 'undefined' || this.editMenu.logoImageUrl == '') &&
        (typeof index == 'undefined' ||
          typeof obj.logoImageUrl == 'undefined' ||
          obj.logoImageUrl == '')
      ) {
        this.profileFileList = [];
      } else {
        this.profileFileList = [{ url: this.editMenu.logoImageUrl }];
      }
      this.menuDialog = true;
    },
    //保存菜单
    menuSave(obj) {
      //校验
      if (!this.osg.validate('editMenu')) {
        return;
      }
      obj.type = this.type;
      obj.parentId = obj.parentId || this.activeNode._id || '0';
      delete obj.functionList;
      delete obj.buttonList;
      this.osg.ajax('function/upsert.do', obj, res => {
        this.osg.toast('保存成功！');
        if (this.activeNode) {
          if (!obj._id) {
            //添加子菜单
            this.activeNode.functionList.push(res.data);
          } else {
            if (this.editMenuIndex) {
              //编辑右侧菜单
              this.activeNode.functionList[this.editMenuIndex] = res.data;
              // this.getMenu();
            } else {
              //左上角编辑菜单
              this.getMenu();
            }
          }
        } else {
          //添加顶级菜单
          this.getMenu();
        }
        this.menuDialog = false;
      });
    },
    //删除菜单按钮
    menuDelete(obj, index) {
      if (!obj && !this.activeNode) {
        this.osg.toast('请选择要删除的菜单！', 'warning');
        return;
      }
      if (!obj && this.activeNode && this.activeNode.functionList.length > 0) {
        this.osg.toast('请先删除子菜单！', 'warning');
        return;
      }
      //有obj就用obj，obj代表删除右侧子菜单
      var name, id;
      if (obj) {
        name = obj.name;
        id = obj._id;
      } else {
        name = this.activeNode.name;
        id = this.activeNode._id;
      }
      this.osg.confirm(`是否确认删除菜单"${name}"`, () => {
        this.osg.ajax('function/remove.do', { functionId: id }, res => {
          this.osg.toast('删除成功!');
          if (index) {
            //右侧删除
            this.activeNode.functionList.splice(index, 1);
          } else {
            //左上角菜单删除
            this.getMenu();
          }
        });
      });
    },
    //添加按钮
    buttonAdd() {
      if (!this.activeNode) {
        this.osg.toast('请选择要添加按钮的菜单！', 'warning');
        return;
      }
      this.editButton = {};
      this.buttonDialog = true;
    },
    //编辑按钮
    buttonEdit(obj, index) {
      this.editButton = this.$util.deepCopy(obj);
      this.buttonDialog = true;
      this.editButtonIndex = index;
    },
    //保存按钮
    buttonSave() {
      var editButton = this.editButton;
      editButton.parentId = editButton.parentId || this.activeNode._id;
      this.osg.ajax('button/upsert.do', editButton, res => {
        this.osg.toast('保存成功！');
        if (editButton._id) {
          //编辑
          // this.editButton = res.entity;
          this.activeNode.buttonList[this.editButtonIndex] = res.entity;
        } else {
          //新建
          this.activeNode.buttonList.push(res.entity);
        }
        this.buttonDialog = false;
      });
    },
    //删除按钮
    buttonDelete(obj, index) {
      this.osg.confirm(`是否确认删除按钮"${obj.label}"？`, () => {
        this.osg.ajax(`button/remove/${obj._id}.do`, {}, res => {
          this.osg.toast('删除成功');
          this.activeNode.buttonList.splice(index, 1);
        });
      });
    },
    formatterSuit(row, column, cellValue, index) {
      return this.osg.codelabel('vipSuit', cellValue);
    },
    onRemove(file, fileList, field) {
      if (file && file.status === 'success') {
        delete this.logoImageUrl;
        delete this.profileFileList;
        // this.menuSave({ logoImageUrl: '' });
      }
    },
    preivew() {
      this.upload.dialogImageUrl = this.logoImageUrl;
      this.upload.dialogVisible = true;
    },
    beforeRemove(file, fileList, field) {
      let status = true;
      if (file && file.status === 'success') {
        status = this.$confirm('确定删除？');
      }
      return status;
    }
  }
  // watch: {
  //   $route() {
  //     this.doInit();
  //   }
  // }
};
</script>
